import React, { useState, useEffect, useRef } from 'react';
import KickImage from 'Reuseables/KickImage';
import { IconContext } from 'react-icons';
import { BsArrowLeftShort } from 'react-icons/bs';
import {
  doFetchCities,
  doFetchProvinces,
  saveShipping,
  updateHistoryShipping,
} from '../../actions/postalCodeAction';
import { connect } from 'react-redux';
import { Modal } from 'reactstrap';
import DataPostalCodeInterface, {
  CountriesInterface,
  ProvinceInterface,
} from '../../interface/reducers/postalCode';
import { GrClose, GrFormDown } from 'react-icons/gr';
import { useOutsideAlerter } from '../../helpers/dom';
import InputNumber from 'Reuseables/InputNumber/InputNumber';

interface stateToProps {
  dataPostalCode: DataPostalCodeInterface;
}

interface ModalEditAddressInterface {
  data: any;
  id: any;
  title: any;
  onToggle: any;
  countries: CountriesInterface[];
  isOpen: boolean;
  doGetCities: (...args: any) => any;
  doGetProvinces: (...args: any) => any;
  provinces: ProvinceInterface[];
  cities: any[];
  toggleEdit: any;
  doSaveShipping: (...args: any) => any;
  doUpdateHistoryShipping: (...args: any) => any;
}

/**
 * Modal for Add New Address Kick Avenue 3.0 Website.
 * Author: Rifqy Zacky Ariadhy (rifqyzackya@gmail.com) updated from ModalAddAddress
 * ===============================================
 * @param {ModalEditAddressInterface} props for this component.
 * @return {JSX.Element}
 */
function ModalEditAddress({
  data,
  id,
  title,
  onToggle,
  countries,
  isOpen,
  doGetCities,
  doGetProvinces,
  provinces,
  cities,
  doUpdateHistoryShipping,
}: ModalEditAddressInterface) {
  const [countryCode] = useState(null);

  // Show active button when input
  const [showActiveButton, setShowActiveButton] = useState(false);

  // Form edit first data
  const [temp, setTemp] = useState<any>(null);
  const [alias, setAlias] = useState('');
  const [currentAddress, setCurrentAddress] = useState('');
  const [currentFullName, setCurrentFullName] = useState('');
  const [currentPostalCode, setCurrentPostalCode] = useState('');
  const [currentNote, setCurrentNote] = useState('');
  const [currentPhoneNumber, setCurrentPhoneNumber] = useState('');
  const [currentCountry, setCurrentCountry] = useState('');
  const [currentProvince, setCurrentProvince] = useState('');
  const [currentCity, setCurrentCity] = useState('');
  const [countryInput, setCountryInput] = useState('');
  const [countryOpen, setCountryOpen] = useState(false);
  const wrapperRefCountry = useRef(null);
  useOutsideAlerter(wrapperRefCountry, () => setCountryOpen(false));
  const [countryList, setCountryList] = useState([
    { code: '', name: 'Select Country' },
  ]);
  const [oldCountryList, setOldCountryList] = useState([
    { code: '', name: 'Select Country' },
  ]);

  const [fullPhoneNumber, setFullPhoneNumber] = useState('')
  const [countryPhoneCode, setCountryPhoneCode] = useState('62')
  const [phoneInput, setPhoneInput] = useState('+62');
  const [phoneNumberList, setPhoneNumberList] = useState<string[]>([])
  const [oldPhoneNumberList, setOldPhoneNumberList] = useState<string[]>([])

  const [phoneOpen, setPhoneOpen] = useState(false);
  const wrapperRefPhone = useRef(null);
  useOutsideAlerter(wrapperRefPhone, () => setPhoneOpen(false));

  // Initial render trigger button
  const [initialRender, setInitialRender] = useState(true);

  useEffect(() => {
    const tempData = data.filter((item: { id: any }) => item.id === id)[0];
    setTemp(tempData);

    setAlias(tempData.alias);
    setCurrentAddress(tempData.street_address);
    setCurrentFullName(tempData.full_name);
    setCurrentPostalCode(tempData.postal_code);
    setCurrentNote(tempData.note);
    setCurrentCountry(tempData.country);
    setCurrentProvince(tempData.province);
    setCurrentCity(tempData.city);

    // const countryCode = tempData.phone_number.slice(1, 3);
    // const phoneNumber = tempData.phone_number.slice(
    //   3,
    //   tempData.phone_number.length,
    // );

    // setCurrentCountryCode(countryCode);
    setCurrentPhoneNumber(tempData.phone_number)
    setFullPhoneNumber(tempData.phone_number);

    if (currentCountry) {
      doGetProvinces(currentCountry);
    }
    if (currentProvince) {
      doGetCities(currentCountry, currentProvince);
    }
  }, [data]);

  useEffect(() => {
    if (currentCountry && currentCountry === 'IDN') {
      doGetProvinces(currentCountry)
    }
  }, [currentCountry])

  useEffect(() => {
    if (temp) {
      if (
        (
          alias !== '' &&
          currentAddress !== '' &&
          currentPhoneNumber !== '' &&
          currentFullName !== '' &&
          currentCountry !== '' &&
          currentProvince !== ''
        )
        &&
        (
          temp.alias !== alias ||
          temp.street_address !== currentAddress ||
          temp.full_name !== currentFullName ||
          temp.postal_code !== currentPostalCode ||
          temp.note !== currentNote ||
          temp.country !== currentCountry ||
          temp.province !== currentProvince ||
          temp.city !== currentCity ||
          fullPhoneNumber !== `+${countryPhoneCode}${currentPhoneNumber}`
        )
      ) {
        setShowActiveButton(true);
      } else {
        setShowActiveButton(false);
      }
    }
  }, [
    alias,
    currentAddress,
    currentFullName,
    currentPostalCode,
    currentNote,
    countryPhoneCode,
    currentPhoneNumber,
    currentCountry,
    currentProvince,
    currentCity,
  ]);

  useEffect(() => {
    if (
      !initialRender &&
      currentCountry &&
      temp.country !== currentCountry &&
      currentCountry !== 'IDN'
    ) {
      setCurrentProvince('');
      setCurrentCity('');
    } else {
      setInitialRender(false);
    }
  }, [currentCountry]);

  useEffect(() => {
    currentCountry === 'IDN' &&
      currentProvince &&
      doGetCities(currentCountry, currentProvince);
  }, [currentProvince]);

  useEffect(() => {
    if (countries && countries.length > 0) {
      let list: Array<any> = [];
      countries.map((i) => {
        if (!list.includes(i.phone_code)) {
          list.push(i.phone_code);
        }
      });
      list.sort((a: number, b: number) => a - b)
      setPhoneNumberList(list)
      setOldPhoneNumberList(list)

      const countryListOptions = countries.map((item) => ({
        code: item.code3 ? item.code3 : item.code,
        name: item.name,
        phone_code: item.phone_code
      }));

      const selectedCountry = countryListOptions.find(
        (item) => item.code === currentCountry,
      );
      
      if (fullPhoneNumber && selectedCountry?.phone_code) {
        let phoneCode = selectedCountry.phone_code
        
        if (currentPhoneNumber && currentPhoneNumber === fullPhoneNumber) {
          const phoneNumber = currentPhoneNumber.slice(
            phoneCode.length + 1,
            currentPhoneNumber.length,
          );
          setCurrentPhoneNumber(phoneNumber);
        }

        setCountryPhoneCode(phoneCode);
        setPhoneInput(`+${phoneCode}`)
      }

      setCountryInput(selectedCountry?.name || '');
      setCountryList(countryListOptions);
      setOldCountryList(countryListOptions);
    }
  }, [countries, currentCountry, fullPhoneNumber]);

  const onChangeCountryInput = (e) => {
    setCountryInput(e.target.value);
    const newCountryList = oldCountryList.filter((t) =>
      t.name.toLowerCase().includes(e.target.value.toLowerCase()),
    );
    setCountryList(newCountryList);
  };

  const onChangePhoneInput = (e) => {
    let inputValue = e.target.value.replace('+', '')
    setPhoneInput(e.target.value);
    const newPhoneList = oldPhoneNumberList.filter((t) =>
      t.toLowerCase().includes(inputValue.toLowerCase()),
    );
    setPhoneNumberList(newPhoneList);
  };

  const handleCountryChange = (e: { target: { value: string } }) => {
    setCurrentCountry(e.target.value);
  };

  const handleProvinceChange = (e: { target: { value: string } }) => {
    setCurrentProvince(e.target.value);
  };

  const handleCityChange = (e: { target: { value: string } }) => {
    setCurrentCity(e.target.value);
  };

  const handlePhoneNumber = (e: Event) => {
    const event = e || window.event;
    // Handle key only accept number
    let key = (event && event.keyCode) || (event && event.which);
    key = String.fromCharCode(key);

    const regex = /[0-9]|\./;

    if (!regex.test(key)) {
      event.returnValue = false;
      if (event.preventDefault) event.preventDefault();
    }
  };

  const updateShipping = async (id: any) => {
    try {
      const payload = {
        id: '',
        alias: alias,
        full_name: currentFullName,
        phone_number: `+${countryPhoneCode}${currentPhoneNumber}`,
        street_address: currentAddress,
        country: currentCountry,
        city: currentCity,
        province: currentProvince,
        note: currentNote,
        postal_code: currentPostalCode,
      };
      await doUpdateHistoryShipping(id, payload);
      onToggle();
    } catch (e) {
      console.log(e.response.data.error);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={onToggle}
      modalClassName={'container-add-address-v3'}
      contentClassName={'main-content'}
    >
      <div className="add-address-header">
        <IconContext.Provider value={{ color: '#242424', size: '20px' }}>
          <div
            style={{
              cursor: 'pointer',
              padding: '2.5px',
              backgroundColor: '#ebebeb',
              borderRadius: '50px',
            }}
            onClick={() => onToggle()}
          >
            <BsArrowLeftShort />
          </div>
        </IconContext.Provider>
        <h4>{title}</h4>
      </div>
      <div className="add-address-content">
        <div>
          <label>Save address as</label>
          <br />
          <input
            onChange={(e) => setAlias(e.target.value)}
            value={alias}
            type="text"
            placeholder="Save Address As (Ex. Office)"
          />
        </div>
        <div>
          <label>Recipient</label>
          <br />
          <input
            onChange={(e) => setCurrentFullName(e.target.value)}
            value={currentFullName}
            type="text"
            placeholder="Recipient"
          />
        </div>
        <div>
          <label>Phone Number</label>
          <br />
          <div className="add-address-phone-input">
            <div className="wrapper-group">
              <div
                className={'text-box group mt-0'}
                onClick={() => (phoneNumberList.length ? setPhoneOpen(true) : null)}
              >
                {/* <p>{bankName && bankName.label ? bankName.label : 'Select Bank'}</p> */}
                <input
                  placeholder={'Code'}
                  value={phoneInput}
                  onChange={onChangePhoneInput}
                />
                <IconContext.Provider value={{ color: '#242424', size: '15px' }}>
                  <span className={'icon-dropdown'}>
                    <GrFormDown />
                  </span>
                </IconContext.Provider>
              </div>
              {phoneOpen && (
                <div
                  ref={wrapperRefPhone}
                  className={'search-country-container mt-0'}
                  style={{ top: 50 }}
                >
                  {phoneNumberList.map((p, i) => {
                    const onClick = () => {
                      setCountryPhoneCode(p)
                      setPhoneOpen(false);
                      setPhoneInput(`+${p}`);
                      setPhoneNumberList(oldPhoneNumberList);
                    };
                    return (
                      <div
                        className={`mt-0 search-country-item${
                          p === countryPhoneCode ? ' selected' : ''
                        }`}
                        onClick={onClick}
                        key={i}
                      >
                        <p>+{p}</p>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
            <InputNumber
              value={currentPhoneNumber}
              onChange={(e) => setCurrentPhoneNumber(e.target.value)}
              placeholder="Phone Number"
            />
          </div>
        </div>
        <div>
          <label>Address</label>
          <br />
          <input
            onChange={(e) => setCurrentAddress(e.target.value)}
            value={currentAddress}
            type="text"
            placeholder="Address"
          />
        </div>
        <div className="add-address-flex-inputs">
          <div className='form-div' style={{ position: 'relative' }}>
            <label>Country</label>
            <br />
            <div
              className={'text-box mt-0'}
              onClick={() => (countryList.length ? setCountryOpen(true) : null)}
            >
              {/* <p>{bankName && bankName.label ? bankName.label : 'Select Bank'}</p> */}
              <input
                placeholder={'Select Country'}
                value={countryInput}
                onChange={onChangeCountryInput}
              />
              <IconContext.Provider value={{ color: '#242424', size: '15px' }}>
                <div className={'icon-dropdown mt-0'}>
                  <GrFormDown />
                </div>
              </IconContext.Provider>
            </div>
            {countryOpen && (
              <div
                ref={wrapperRefCountry}
                className={'search-country-container mt-0'}
              >
                {countryList.map((c) => {
                  const onClick = () => {
                    setCurrentCountry(c.code);
                    setCountryOpen(false);
                    setCountryInput(c.name);
                    setCountryList(oldCountryList);
                  };
                  return (
                    <div
                      className={`mt-0 search-country-item${
                        c.code === currentCountry ? ' selected' : ''
                      }`}
                      onClick={onClick}
                      key={c.code}
                    >
                      <p>{c.name}</p>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
          <div className='form-div'>
            {currentCountry && currentCountry !== 'IDN' ? (
              <>
                <label>State / Province</label>
                <br />
                <input
                  onChange={handleProvinceChange}
                  value={currentProvince}
                  type="text"
                  placeholder="State or Province"
                />
              </>
            ) : (
              <>
                <label>Province</label>
                <br />
                <select
                  onChange={handleProvinceChange}
                  value={currentProvince}
                  name=""
                  id=""
                >
                  <option value="" selected>
                    Select Province
                  </option>
                  {provinces &&
                    provinces.map((item) => (
                      <option key={item.id} value={item.name}>
                        {item.name}
                      </option>
                    ))}
                </select>
              </>
            )}
          </div>
        </div>
        <div className="add-address-flex-inputs">
          <div className='form-div' style={{ marginRight: '20px' }}>
            <label>City</label>
            <br />
            {currentCountry && currentCountry !== 'IDN' ? (
              <input
                onChange={handleCityChange}
                value={currentCity}
                type="text"
                placeholder="City"
              />
            ) : (
              <select
                onChange={handleCityChange}
                value={currentCity}
                name=""
                id=""
              >
                <option value="" selected>
                  Select City
                </option>
                {cities ? (
                  cities.map((item) => (
                    <option key={item.id} value={item.name}>
                      {item.name}
                    </option>
                  ))
                ) : (
                  <option>Cities option not found..</option>
                )}
              </select>
            )}
          </div>
          <div className='form-div'>
            <label htmlFor="">Zip Code</label>
            <br />
            <input
              onChange={(e) => setCurrentPostalCode(e.target.value)}
              value={currentPostalCode}
              type="number"
              placeholder="Enter Zip Code"
            />
          </div>
        </div>
        <div>
          <label>Note</label>
          <br />
          <textarea
            onChange={(e) => setCurrentNote(e.target.value)}
            value={currentNote}
            type="text"
            placeholder="Enter Your Note Here (Optional)"
          />
        </div>
      </div>
      <div className="add-address-footer">
        <span
          className={!showActiveButton ? 'disabled' : ''}
          onClick={() => {
            showActiveButton ? updateShipping(id) : (() => {})();
          }}
        >
          Save Address
        </span>
      </div>
      <div className={'close-button'} onClick={() => onToggle()}>
        <IconContext.Provider value={{ color: '#242424', size: '12px' }}>
          <div>
            <GrClose />
          </div>
        </IconContext.Provider>
      </div>
    </Modal>
  );
}

const mapStateToProps = (state: stateToProps) => ({
  provinces: state.dataPostalCode.provinces.data,
  cities: state.dataPostalCode.cities.data,
});

const mapDispatchToProps = (dispatch: (...args: any) => any) => ({
  doGetProvinces: (country: any) => dispatch(doFetchProvinces(country)),
  doGetCities: (country: any, province: any) =>
    dispatch(doFetchCities(country, province)),
  doSaveShipping: (payload: any) => dispatch(saveShipping(payload)),
  doUpdateHistoryShipping: (id: any, payload: any) =>
    dispatch(updateHistoryShipping(id, payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalEditAddress);
